import { UserBooking } from '../../user-bookings/schemas'

export abstract class UserCanAdd {
  protected today: Date

  constructor() {
    this.today = new Date()
    this.today.setHours(0, 0, 0, 0)
  }

  abstract check(
    userBookings: UserBooking[],
    campsiteSlug: string,
    token?: string,
  ): UserBooking
}
